import { createIcon } from '../icon'
import ClearIcon from '../svg/ClearIcon'

export const ClearIconDefault = createIcon(ClearIcon)
